import { ATDLInterfaceDependencyModel } from "./atdl-interface-dependency.model";
import { ATDLNControlType } from "../enums/atdl-control-type.enum";

export class ATDLInterfaceAuxiliaryModel {
  public icdId: string = null;
  public refName: string = null;
  public refIcdId: string = null; // owner id
  public label: string = null;
  public icdType: ATDLNControlType = null;
  public initValue: boolean = null;
  public value: boolean = null;
  //
  public dependencies: Array<ATDLInterfaceDependencyModel> = null;
}
